import { EventTypeEnum } from '../../enums/event/event-type-enum';

export const snackbarIconsMapper = new Map<EventTypeEnum, string>([
  [EventTypeEnum.SUCCESS, 'check-circle-bold'],
  [EventTypeEnum.ERROR, 'close-circle-bold'],
  [EventTypeEnum.INFO, 'info-circle-bold'],
  [EventTypeEnum.WARNING, 'danger-triangle-bold'],
]);
